
<template>
  <div class="user-name">
    <Head :info="headInfo"></Head>
    <div class="tips">长按图片可进行保存哟~</div>
    <div class="user-container">
       <div class="each-img" v-for="(item,index) in list" :key="index">
           <img :src="item.img" alt="" @click="chooseImg(index)">
           <div class="position">
               <img src="../../assets/images/choose.png"  @click="chooseImg(index)" v-if="item.checked" alt="">
           </div>
       </div>
    </div>
    <div class="footer" @click="download()">
            点击预览
    </div>
  </div>
</template>

<script type="text/babel">

import Head from '@/component_basics/Head'
import Cell from '@/component_basics/Cell'

// 组件
export default {
  name: 'download',
  components: {Head,Cell},
  data() {
    return {
        headInfo:{
            name: '海报下载'
        },
        disabled:true, 
        value:0,
        checked:'',
        host: location.host,
        list:[
            {
                img:require('../../assets/images/product1.png'),
                checked:false,
                url:'product1.jpg '
            },
            // {
            //     img:require('../../assets/images/new-chain.png'),
            //     checked:false,
            //     url: 'new-chain.jpg'
            // },
            {
                img:require('../../assets/images/product2.png'),
                checked:false,
                url: 'product2.png'
            },
        ]
        
    };
  },
  created() {
  },
 mounted() {
 },
  methods: {
      validate() {
          if(this.value&&this.checked) {
              this.disabled = false
          } else {
              this.disabled = true
          }
      },
      download() {
          let targetindex = 0
          let imgIdc = {
              0: 'http://refereestage.zhangyuxia.com.cn/img/product1.png',
            //   1: 'http://refereestage.zhangyuxia.com.cn/img/new-chain.png',
              1: 'http://refereestage.zhangyuxia.com.cn/img/product2.png',
          }
          this.list.forEach((res,index)=> {
              if(res.checked) {
                //   let alink = document.createElement("a");
                //   alink.href = this.host+ '/img/'+ res.url;
                  targetindex=index
                //   alink.download = "pic"; //图片名
                //   alink.click();
                
                console.log(this.host+ '/img/'+ res.url)

              }
          })
          this.saveImg(imgIdc[targetindex]) 
          
      },
      saveImg(Url) {
           var blob=new Blob([''], {type:'application/octet-stream'});
            var url = URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = Url;
            a.download = Url.replace(/(.*\/)*([^.]+.*)/ig,"$2").split("?")[0];
            var e = document.createEvent('MouseEvents');
            e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
            a.dispatchEvent(e);
            URL.revokeObjectURL(url);
      },
      chooseImg(index) {
          this.list.forEach(item=> {
              item.checked = false
          })
          this.list[index].checked = !this.list[index].checked
        //   let num = 0
        //   this.list.forEach(item=> {
        //       if(item.checked){
        //           num++
        //       }
        //   })
        //   this.value = num
      }
  }
};
</script>

<style lang="less" scoped>
.user-name{
    background-color: @colorBg;
    .tips{
        background: #FFD8AF;
        color: #e9b278;
    }
    .user-container{

        display: flex;
        padding: 20px 17px;
    }
    .each-img{
        width: 104px;
        height: 185px;
        overflow: hidden;
        margin-right: 15px;
        position: relative;
        img{
            width: 104px;
        }
        .position{
            position: absolute;
            width: 18px;
            height: 18px;
            box-sizing: border-box;
            top: 6px;
            right: 10px;
            border: 1px solid #e7e7e7;
            border-radius: 50%;
            img{
                width: 22px;
                height: 19px;
            }
            background-color: #fff;
        }
    }
    .footer{
        height: 50px;
        background-color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        bottom: 0;
        width: 100%;
        span{
            color: red;
        }
    }
}
</style>
